import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { PremeetingBloc } from "./PremeetingBloc";
import { useContext } from "react";

export const PremeetingContext = createBlocContext<PremeetingBloc>();

export function usePremeetingContext() {
  const ctx = useContext(PremeetingContext);
  return ctx;
}

export const PremeetingBlocProvider = createBlocProvider<PremeetingBloc>(
  PremeetingBloc.create(),
  PremeetingContext
);
